import React, { useState } from "react";
import { PrimaryButton } from "./PrimaryButton";
const MIN_AGE = 18;
const MAX_AGE = 99;
interface AgeInputProps {
  labelledBy: string;
  initial?: string;
  onSubmit: (age: string) => void;
}
export function AgeInput({
  labelledBy,
  initial = "",
  onSubmit
}: AgeInputProps) {
  const [value, setValue] = useState(initial);
  const age = Number(value);
  const valid = value !== "" && age >= MIN_AGE && age <= MAX_AGE;
  const showError = value.length >= 2 && !valid;
  return <form className="mt-7" onSubmit={e => {
    e.preventDefault();
    if (valid) onSubmit(String(age));
  }} data-id="element-1" data-mp="3sd9a4ab0wmhk">
      <div className={`flex items-baseline justify-center gap-3 rounded-2xl border-2 bg-white px-5 py-6 transition-colors duration-150 focus-within:border-rose-600 ${showError ? "border-coral-600" : "border-blush-100"}`} data-id="element-2" data-mp="18amfzp69d73">
        <input type="text" inputMode="numeric" pattern="[0-9]*" autoFocus maxLength={2} aria-labelledby={labelledBy} aria-invalid={showError} aria-describedby="age-help" value={value} onChange={e => setValue(e.target.value.replace(/\D/g, "").slice(0, 2))} placeholder="42" className="w-28 bg-transparent text-center font-serif text-6xl font-semibold tabular-nums text-cocoa placeholder:text-blush-200 focus:outline-none" data-id="element-3" data-mp="27x5q5mbg0jxf" />
        <span className="font-serif text-2xl text-cocoa-soft" data-id="element-4" data-mp="1bklqci0v1mjy">años</span>
      </div>
      <p id="age-help" className={`mt-2 text-center text-sm ${showError ? "text-coral-600" : "text-cocoa-faint"}`} data-id="element-5" data-mp="16oek0o4jy91h">
        {showError ? `Ingresá una edad entre ${MIN_AGE} y ${MAX_AGE} años.` : "Escribí tu edad en números."}
      </p>
      <div className="mt-6" data-id="element-6" data-mp="3nc8ypzz29nhz">
        <PrimaryButton type="submit" disabled={!valid} data-id="element-7" data-mp="3ncinjk8ddom3">
          Continuar
        </PrimaryButton>
      </div>
    </form>;
}